import styled from "styled-components";

import { FlexBox } from "@braze/beacon-core";
import { getSpacing } from "@braze/beacon-styling";

export const HeaderWrapper = styled(FlexBox)<{ isScrolled: boolean; isShowingSalesBanner: boolean }>`
  position: sticky;
  flex-direction: column;
  top: 0;
  width: 100%;
  height: 78px;
  background-color: #300266;
  transition: top 0.3s ease;
  justify-content: center;
  align-items: center;
  z-index: 10;
  @media (min-width: 1024px) {
    display: none;
  }
  @media (max-width: 1024px) {
    top: ${(props) => (props.isShowingSalesBanner ? "60px" : "0")};
  }
  @media (max-width: 500px) {
    top: ${(props) => (props.isShowingSalesBanner ? "50px" : "0")};
  }
`;

export const BackgroundBlur = styled.div<{ isScrolled: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  backdrop-filter: blur(${(props) => (props.isScrolled ? "5px" : "0px")});
  transition: backdrop-filter 0.3s ease;
`;

export const Logo = styled.img`
  height: 48px;
  transition: height 0.3s ease;
  z-index: 3;
  margin: ${getSpacing("xl")} 0;
`;
